import { render, staticRenderFns } from "./CardNotification.vue?vue&type=template&id=4c547853"
import script from "./CardNotification.vue?vue&type=script&lang=js"
export * from "./CardNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports